enum EnumGroupFilters {
  my = 'my',
  team = 'team',
  all = 'all',
}

export default EnumGroupFilters;
